module.exports = __webpack_public_path__ + "static/media/Project2_Fig6.48fe80b9.png";